<style lang="scss">
.vslist-detail {
  min-height: 20px;
  padding: 16px;
  margin-bottom: 20px;
  background-color: #f3f7f9;
  border: 1px solid #e4eaec;
  border-radius: 3px;
  width: 80%;
}
.margin-right-10{
    margin-right: 10px;
}
.margin-left-100{
    margin-left: 100px;
}
</style>

<template>
    <div>
        <!-- 编辑仓库 -->
        <div class="lookinfo" v-show="editWarehouse">
            <Breadcrumb class="tablelist-header">
                <BreadcrumbItem>{{$t('erp.virtualstore.editladder',{defaultValue:'编辑阶梯'})}}</BreadcrumbItem>
            </Breadcrumb>
            <Alert class="padding-10">
                <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
            </Alert>
            <div class="bg-fff shadow padding-bottom-20">
                <header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
                <Form :label-width="100" ref="form" :model="formData" class="margin-15">
                    <FormItem :label="$t('global.common.name',{defaultValue:'名称'})">
                        <a class="item-content" @click="seeDetail">{{formData.name}}</a>
                    </FormItem>
                    <FormItem :label="$t('global.common.project',{defaultValue:'项目'})">
                        <span class="item-content">{{formData.lineId|transferText('name',products)}}</span>
                    </FormItem>
                    <FormItem label='ERPSKU'>
                        <span class="margin-right-10">{{formData.erpSku}}</span>
                        <!-- <Button @click="seeDetail">查看详细信息</Button> -->
                    </FormItem>
                    <FormItem prop="stockGroups" :label="$t('erp.virtualstore.openwirtualware',{defaultValue:'开启虚拟仓'})">
                        <CheckboxGroup v-model="formData.stockGroups">
                            <Checkbox :label="1" >T1</Checkbox>
                            <Checkbox :label="2" >T2</Checkbox>
                            <Checkbox :label="3" >T3</Checkbox>
                            <Checkbox :label="4" >T4</Checkbox>
                            <Checkbox :label="5" >T5</Checkbox>
                        </CheckboxGroup>
                    </FormItem>
                    <FormItem prop="organizationWarehouses" :label="$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'})">
                        <div v-for="(item,index) in warehouseLists" :key="index">
                            {{item.warehouseTitle}}({{item.warehouseCode}})
                        </div>
                    </FormItem>
                    <FormItem :label="$t('fbb.costmanage.explain',{defaultValue:'说明'})">
                        <Input v-model="formData.description" :rows="4" type="textarea" disabled/>
                    </FormItem>
                </Form>
                <footer class="text-center">
                    <Button type="primary" class="width-15per" @click="nextChannel">{{$t('fbb.accountmanage.next_step',{defaultValue:'下一步'})}}</Button>
                    <Button class="width-15per" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
                </footer>
            </div>
        </div>
        <!-- 选择店铺 -->
        <div class="lookitem" v-show="editChannel">
            <Breadcrumb class="tablelist-header">
                <BreadcrumbItem>{{$t('fbb.inbound.choose',{defaultValue:'选择'})}}{{$t('global.common.channel',{defaultValue:'店铺'})}}</BreadcrumbItem>
            </Breadcrumb>
            <Alert class="padding-10">
                <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
            </Alert>
            <Row class="bg-fff shadow padding-bottom-20">
                <Col span='24'>
                <header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
                </Col>
                <Col span='12'>
                <span class="item-label">{{$t('global.common.name',{defaultValue:'名称'})}}：</span>
                <a class="item-content" @click="seeDetail">{{formData.name}}</a>
                </Col>
                <Col span='12'>
                <span class="item-label">{{$t('global.common.project',{defaultValue:'项目'})}}：</span>
                <span class="item-content">{{formData.lineId|transferText('name',products)}}</span>
                </Col>
                <Col span='12'>
                <span class="item-label">ERPSKU：</span>
                <span class="item-content">{{formData.erpSku}}</span>
                </Col>
                <Col span='24'>
                <Form :label-width="100" ref="formChannel">
                    <section v-for="(item,index) in svRules" class="clearfix vslist-detail margin-left-100" :key="index">
                        <header class="item-label">{{item.stockGroupName}}</header>
                        <div v-if="item.id">
                            {{$t('erp.virtualstore.usestores',{defaultValue:'可用店铺'})}}:
                            <div style="margin-left:100px;">
                                <div v-for="(json,index) in item.stockVirtualGroupRuleAccountEntity" :key="index">
                                    {{json.accountName}}({{json.accountFlag}})
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            {{$t('erp.virtualstore.setusestores',{defaultValue:'设定可用店铺'})}}:
                            <div style="margin-left:100px;">
                                <Transfer
                                    :data="accountsTarget"
                                    :target-keys="ruleAccounts[index]"
                                    :list-style="listStyle"
                                    filterable
                                    :filter-method="filterMethod"
                                    @on-change="(targetKeys)=>{handleStoreChange(targetKeys,index)}"></Transfer>
                            </div>
                        </div>
                    </section>
                </Form>
                </Col>
                <Col span="24" class="text-center padding-10">
                <Button type="primary" class="width-15per" @click="lastWarehouse">{{$t('erp.virtualstore.laststep',{defaultValue:'上一步'})}}</Button>
                <Button type="primary" class="width-15per" @click="nextAllot">{{$t('fbb.accountmanage.next_step',{defaultValue:'下一步'})}}</Button>
                <Button class="width-15per" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
                </Col>
            </Row>
        </div>
        <!-- 编辑比例 -->
        <div class="lookitem" v-show="editAllot">
            <Breadcrumb class="tablelist-header">
                <BreadcrumbItem>{{$t('erp.virtualstore.editwareallocratio',{defaultValue:'编辑虚拟仓分配比例'})}}</BreadcrumbItem>
            </Breadcrumb>
            <Alert class="padding-10">
                <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
            </Alert>
            <Row class="bg-fff shadow padding-bottom-20">
                <Col span='24'>
                <header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
                </Col>
                <Col span='12'>
                <span class="item-label">{{$t('global.common.name',{defaultValue:'名称'})}}：</span>
                <a class="item-content" @click="seeDetail">{{formData.name}}</a>
                </Col>
                <Col span='12'>
                <span class="item-label">{{$t('global.common.project',{defaultValue:'项目'})}}：</span>
                <span class="item-content">{{formData.lineId|transferText('name',products)}}</span>
                </Col>
                <Col span='12'>
                <span class="item-label">ERPSKU：</span>
                <span class="item-content">{{formData.erpSku}}</span>
                </Col>
                <Col span='24'>
                <Form :label-width="100" ref="formAllot">
                    <section v-for="(item,index) in svRules" class="clearfix" :key="index">
                        <header class="item-label">{{item.stockGroupName}}</header>
                        <section class="item-content vslist-detail">
                            <div class="clearfix padding-top-5" v-for="data in item.orgWarehouseIds" :key="data.id">
                                <span class="width-80per pull-left">{{data.warehouseTitle}}({{data.warehouseCode}})</span>
                                <InputNumber class="pull-left" v-model="data.assignPercent"/>
                                %
                            </div>
                        </section>
                    </section>
                </Form>
                </Col>
                <Col span="24" class="text-center padding-10">
                <Button type="primary" class="width-15per" @click="lastChannel">{{$t('erp.virtualstore.laststep',{defaultValue:'上一步'})}}</Button>
                <Button type="primary" class="width-15per" @click="commitForm">{{$t('erp.distribution.confirm_submit',{defaultValue:'提交'})}}</Button>
                <Button class="width-15per" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
                </Col>
            </Row>
        </div>
        <!-- 查看信息按钮 -->
        <Modal
        class="hidefooter"
        v-model='operate.show'
        :mask-closable='false'
        v-bind="operate">
            <component :is="operate.component" @on-close="operate={}" v-bind="operate" v-if="operate.show"/>
            <footer slot="footer" v-show="false"></footer>
        </Modal>
        <Spin size="large" fix v-if="loading"></Spin>
        <!-- <Spin size="large" fix v-if="loading"></Spin> -->
        
    </div>
</template>

<script>

    import {mapState,mapGetters} from 'vuex'
    import {HttpProductErpSku} from '@/service/boss/dictionary'
    import {
        HttpVsDetail, HttpEditorLadder
    } from '@/service/boss/allot';
    import compDetail from './detail';
    export default {
        components: {
            compDetail
        },
        data() {
            return {
                loading: false,
                // type: this.$route.params.type,
                id: this.$route.params.id,
                listStyle: {
                    width: "260px",
                    height: '360px',
                },
                formData: {
                    name: '',
                    lineId: '',
                    erpSku: '',
                    rules: [],
                    stockGroups: [],
                    organizationWarehouses: [],
                    description: '',
                    productId: '',
                },
                required: [{
                    required: true,
                    message: this.$t('global.common.required',{defaultValue:'该信息不能为空,请填写'})
                }],
                editWarehouse:true,
                editChannel:false,
                editAllot:false,
                svRules: [],
                operate: {
				    id: null,
				    title: "",
				    show: false,
                    component: null
                },
                // 新增数据
                warehouseLists:'',
                ruleAccounts: [],
                resDatas:'',
                channels:[],
            }
        },
        created() {
            this.getDetail();
        },
        computed: {
            ...mapState('boss',['products','accounts']),
            ...mapGetters('boss',['warehouses']),
            warehousesTarget() {
                return this.warehouses.map(item => {
                    return {
                        key: item.id,
                        label: `${item.title}(${item.code})`,
                    }
                })
            },
            accountsTarget() {
                return this.accounts.map((item) => {
                    return {
                        label: `${item.title}(${item.flag})`,
                        key: item.id,
                    }
                })
            },
        },
        methods: {
            // 点击target
            handleStoreChange(targetKeys, index) {
                this.$set(this.ruleAccounts, index, targetKeys);
                let arr = [];
                targetKeys.map(item=>{
                    this.accounts.map(json=>{
                        if(item == json.id){
                            let data = {
                                accountId:json.id
                            }
                            arr.push(data)
                        }
                    })
                })
                this.svRules[index].accountIds = arr;
            },
            
            async getDetail(value) {
                this.loading = true;
                HttpVsDetail({
                    id: this.id
                }).then(res => {
                    this.resDatas = res.data
                    this.handleResponse(res.data);
                    this.formData.rules = res.data.stockVirtualGroupRules;
                    this.loading = false;
                    if(value=='lastware'){
                        this.editWarehouse = true;
                        this.editChannel = false;
                        this.editAllot = false;
                    }
                }, err => {
                    this.loading = false;
                    this.errorMessage(err.message);
                });
            },
            async nextChannel(){
                let valid = await this.$refs['form'].validate();
                if (!valid) return;
                this.handleformDta(this.formData);
                this.editWarehouse = false;
                this.editChannel = true;
                this.editAllot = false;
            },
            nextAllot() {
                // console.log(this.ruleAccounts)
                const has = this.ruleAccounts.every(val => {
                    return val.length > 0
                });
                if (!has) {
                    this.$Message.warning(this.$t('global.common.choose',{defaultValue:'请选择'})+this.$t('global.common.channel',{defaultValue:'店铺'}));
                    return false;
                }
                this.formData = {...this.formData};
                this.editAllot = true;
                this.editWarehouse = false;
                this.editChannel = false;
            },
            closeloading(){
                this.loading = false;
            },
            lastWarehouse(){
                this.getDetail('lastware')
            },
            lastChannel(){
                this.editAllot = false;
                this.editWarehouse = false;
                this.editChannel = true;
            },
            handleResponse(data = {}) {
                // console.log(data)
                let {name, lineId, erpSku, description, productId, stockVirtualGroupRules = []} = data;
                let organizationWarehouses = (stockVirtualGroupRules[0] || {}).stockVirtualGroupRuleItemEntity || [],
                    stockGroups = stockVirtualGroupRules.map(item => {
                        return item.stockGroupId;
                    });
                this.warehouseLists = organizationWarehouses;
                
                organizationWarehouses = organizationWarehouses.map(item => {
                    return item.orgWarehouseId;
                });
                this.formData = {name, lineId, erpSku, description, productId, organizationWarehouses, stockGroups};
            },
            handleformDta(data){
                // console.log(data)
                let { name, lineId, erpSku, description, status } = data;
                // console.log(data.stockGroups)
                this.svRules = (data.stockGroups || []).map((item, index) => {
                    let accountslist = data.rules.filter((items) => {
                        return items.stockGroupId == item;
                    });
                    if (accountslist.length > 0) {
                        accountslist = accountslist[0].stockVirtualGroupRuleAccountEntity;
                    }
                    let itemlist = data.organizationWarehouses || [];
                    itemlist = itemlist.map((ware) => {
                        let warelist = data.rules.filter((rule) => {
                            return rule.stockGroupId == item;
                        });
                        if (warelist.length > 0) {
                            warelist = warelist[0].stockVirtualGroupRuleItemEntity;
                        }
                        const lastWare = warelist.filter((list) => {
                            return list.orgWarehouseId == ware;
                        });
                        if (lastWare.length == 0) {
                            const wareEntity = this.warehouses.filter((house) => {
                                return house.id == ware;
                            })[0];
                            return {
                                warehouseTitle: wareEntity.title,
                                warehouseCode: wareEntity.code,
                                orgWarehouseId: ware,
                                assignPercent: 0,
                                // id: item + '_' + wareEntity.id
                            }
                        } else {
                            return lastWare[0];
                        }
                    });
                    let rule = data.rules.filter((items) => {
                        return items.stockGroupId == item;
                    })[0];
                    if (!rule) {
                        rule={};
                        rule.stockGroupId = item;
                        if (item == 1) {
                            rule.stockGroupName = 'T1'
                        }
                        if (item == 2) {
                            rule.stockGroupName = 'T2'
                        }
                        if (item == 3) {
                            rule.stockGroupName = 'T3'
                        }
                        if (item == 4) {
                            rule.stockGroupName = 'T4'
                        }
                        if (item == 5) {
                            rule.stockGroupName = 'T5'
                        }
                    }
                    rule.accountIds = accountslist;
                    rule.orgWarehouseIds = itemlist;
                    // 编辑可用店铺,没有则默认展示
                    this.$set(this.ruleAccounts, index, rule.accountIds.map(json => {
                        return json.accountId;
                    }));
                    return rule;
                });
                // console.log(this.svRules)
            },
            handleRequest() {
                // console.log()
                let warehousesList = [];
                // console.log(this.formData)
                warehousesList = this.formData.rules.map((items,index) => {
                    let ruleid = items.id;
                    let stockGroupId = items.stockGroupId;
                    let stockGroupName = items.stockGroupName;
                    let orgWarehouseIds = items.orgWarehouseIds.map((item) => {
                        return {
                            orgWarehouseId: item.orgWarehouseId,
                            assignPercent: item.assignPercent
                        }
                    })
                    return {
                        id: ruleid,
                        stockGroupId: stockGroupId,
                        stockGroupName: stockGroupName,
                        orgWarehouseIds: orgWarehouseIds
                    }
                })
                return warehousesList
            },            
            // 查看页面
            seeDetail(){
                this.operate = {
                    id:this.id,
                    title: this.$t('global.common.operation_see',{defaultValue:'查看'}),
                    component: 'compDetail',
                    show: true,
                    width: 760,

                }
            },
            cancel() {
                this.$router.push({name: "vstorelist"})
            },
            // 提交
            commitForm(){
                const wareids = this.warehouseLists.map(item=>{
                    return item.orgWarehouseId
                })
                const string = wareids.join(",")
                let data = {
                    id: parseInt(this.id),
                    orgId: this.resDatas.orgId,
                    lineId: this.resDatas.lineId,
                    erpSku: this.resDatas.erpSku,
                    name: this.resDatas.name,
                    description: this.resDatas.description,
                    orgWarehouseIds: string,
                    stockVirtualGroupRules:this.svRules,
                }
                HttpEditorLadder(data).then( res => {
                    this.$Message.success(res.message);
                    this.loading = false;
                    this.$router.push({ name: "vstorelist" })
                },err => {
                    if(err.code==500){
                        this.$Message.error(this.$t('erp.virtualstore.nullnumber',{defaultValue:'数值不能为空'}));
                        this.loading = false;
                    }else{
                        this.errorMessage(err.message);
                        this.loading = false;
                    }
                })
            },
            // 添加自定义搜索函数,不区分大小写
            filterMethod (data, query) {
                return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
            },
        },
        beforeDestroy() {
            
        },
    }
</script>

